"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseErrorBody = parseErrorBody;
exports.parseApiError = parseApiError;
const ApiError_1 = require("../ApiError");
// El backend responde con JSON indentado (saltos de línea incluidos),
// por eso [\s\S] en lugar de "." (que no cruza saltos de línea).
const JSON_BLOCK = /\{[\s\S]*\}/;
function parseErrorBody(raw) {
    const match = raw.match(JSON_BLOCK);
    if (!match)
        return undefined;
    try {
        const parsed = JSON.parse(match[0]);
        return parsed && typeof parsed === 'object'
            ? parsed
            : undefined;
    }
    catch {
        return undefined;
    }
}
function getErrorMessage(error) {
    if (error instanceof Error)
        return error.message;
    if (typeof error === 'string')
        return error;
    if (error && typeof error === 'object' && 'message' in error) {
        return String(error.message);
    }
    return 'An error occurred';
}
/**
 * Normaliza cualquier error capturado en un `ApiError`, extrayendo el
 * `title`/`detail` del backend cuando viene embebido en el mensaje.
 */
function parseApiError(error) {
    if (error instanceof ApiError_1.ApiError)
        return error;
    const message = getErrorMessage(error);
    const body = parseErrorBody(message);
    return new ApiError_1.ApiError(message, {
        status: body?.status,
        title: body?.title,
        detail: body?.detail ?? (body ? undefined : message),
        name: error instanceof Error ? error.name : 'ApiError',
    });
}
